import Vue from "vue";
import Hammer from "./hammer";

Vue.use(Hammer);
